import { render } from "./UserControls.vue?vue&type=template&id=3367b51b&scoped=true"
import script from "./UserControls.vue?vue&type=script&lang=js"
export * from "./UserControls.vue?vue&type=script&lang=js"

import "./UserControls.vue?vue&type=style&index=0&id=3367b51b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3367b51b"]])

export default __exports__